import { render } from "./lessonDiscuss.vue?vue&type=template&id=554c3513&scoped=true"
import script from "./lessonDiscuss.vue?vue&type=script&lang=js"
export * from "./lessonDiscuss.vue?vue&type=script&lang=js"

import "./lessonDiscuss.vue?vue&type=style&index=0&id=554c3513&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554c3513"]])

export default __exports__